export default "__VITE_ASSET__RHGKRmwU__"